import React from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { obtenerDatos } from "services/crudFirebase";

const PriceList = () => {
	const history = useHistory();

	useEffect(async () => {
		const [{LinkDrive}] = await obtenerDatos("ListaPrecios");
		// const priceListDriveLink =
		// 	"https://docs.google.com/spreadsheets/d/1OcDUd4FJkdkd1R6l265TIqpx7K6VKgkY/edit?usp=sharing&ouid=114587411475989365729&rtpof=true&sd=true";
		//window.open(LinkDrive);
		window.location.href = LinkDrive;
	}, []);

	history.push("/");
	return <div>Lista Precios Celular Fire</div>;
};

export default PriceList;
